import { migrateConversationSortDirection } from '@/helpers/conversationSort'

export function createInitialState() {
  migrateConversationSortDirection(localStorage)
  return {
    objects: {},
    savingCount: 0,
    omniSearchOpen: false,
    pendingMessages: {},
    loggedInUser: {},
    hideNumbers: false,
    ongoingCall: null,
    pusher: null,
    conversationSortBy: localStorage.getItem('conversationSortBy') || 'recent',
    conversationSortDirection: localStorage.getItem('conversationSortDirection') || 'desc',
    activePlatformPreference: localStorage.getItem('activePlatform') || null,
    franchise: null,
    franchiseMerchants: [],
    franchiseBlueprint: null,
    activeFranchiseMerchantId: localStorage.getItem('franchiseMerchantId') || null
  }
}
